import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busserviceforpicniicinpune() {



  const cardData =
  {
    keyword: 'Bus Service for Picnic in Pune ',
    heading: 'Sanavi Travels: Bus Service for Picnic in Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus Service for Picnic in Pune, providing safe, comfortable, and well-organized transportation solutions for schools, colleges, corporate teams, families, and large groups planning day outings and picnic trips. Our fleet includes Non-AC and AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, ensuring spacious seating, ample luggage space, and a smooth ride for short and long picnic journeys. With experienced and courteous drivers, flexible rental packages, transparent pricing, and punctual service, Sanavi Travels makes picnic travel stress-free and enjoyable. We offer convenient doorstep pickup from all major areas of Pune such as Hinjewadi, Wakad, Baner, Aundh, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Railway Station, covering popular picnic destinations including Sinhagad Fort, Lonavala, Lavasa, Mulshi, Pawna Lake, Panshet, Bhor, Mahabaleshwar, and nearby tourist spots. Choose Sanavi Travels for dependable bus service for picnic in Pune, ensuring safety, comfort, and a memorable group travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
    {
      "name": "Bus Service for Picnic in Pune",
      "description": "Bus Service for Picnic in Pune provides reliable and spacious buses for group picnics within Pune and nearby destinations. Ideal for families, friends, and corporate groups, these buses ensure comfortable seating, ample luggage space, and professional drivers. Perfect for day trips, weekend outings, and organized picnic events, this service emphasizes safety, punctuality, and an enjoyable travel experience for all passengers."
    },
    {
      "name": "Picnic Bus Hire Pune",
      "description": "Picnic Bus Hire Pune offers flexible rental options for group picnics, providing well-maintained buses suitable for short or long trips. Professional drivers manage routes efficiently, ensuring safe and timely travel. These buses are ideal for school outings, family get-togethers, corporate picnic events, and local sightseeing."
    },
    {
      "name": "AC Picnic Bus Pune",
      "description": "AC Picnic Bus Pune provides air-conditioned buses for a comfortable and cool travel experience during picnics. Ideal for families, corporate groups, and friends, these buses ensure spacious seating, luggage-friendly interiors, and professional chauffeurs for smooth and stress-free journeys."
    },
    {
      "name": "Family Picnic Bus Pune",
      "description": "Family Picnic Bus Pune ensures safe and convenient transport for family picnics and outings. Spacious interiors, comfortable seating, and professional drivers allow families to enjoy their day trips without worry. Perfect for weekend trips, short getaways, or visits to nearby parks and tourist spots."
    },
    {
      "name": "School Picnic Bus Pune",
      "description": "School Picnic Bus Pune offers reliable buses for student excursions and school outings. With ample seating, safety features, and experienced chauffeurs, these buses provide a secure and comfortable travel experience for children and staff, making educational trips and recreational outings hassle-free."
    },
    {
      "name": "Corporate Picnic Bus Pune",
      "description": "Corporate Picnic Bus Pune caters to office teams and corporate groups organizing picnic events. Buses are equipped with spacious seating, luggage space, and professional drivers to ensure timely arrival, safe travel, and a pleasant journey for employees and colleagues."
    },
    {
      "name": "Affordable Picnic Bus Pune",
      "description": "Affordable Picnic Bus Pune provides budget-friendly rental options for group picnics without compromising on comfort or safety. Well-maintained vehicles, professional chauffeurs, and spacious seating ensure an economical yet enjoyable travel experience for families, friends, and corporate groups."
    },
    {
      "name": "Chauffeur Driven Picnic Bus",
      "description": "Chauffeur Driven Picnic Bus provides skilled and experienced drivers for hassle-free picnic trips. Passengers can relax while the driver navigates traffic and routes safely. Perfect for families, friends, and corporate groups planning local or outstation picnic journeys."
    },
    {
      "name": "Group Travel Picnic Bus Pune",
      "description": "Group Travel Picnic Bus Pune caters to large groups attending picnic events or excursions. Buses are spacious, well-maintained, and comfortable for long or short trips. Professional drivers ensure punctual arrivals, smooth travel, and a convenient experience for all passengers."
    },
    {
      "name": "Best Picnic Bus Service Pune",
      "description": "Best Picnic Bus Service Pune offers top-quality buses with professional drivers for a superior travel experience. Comfortable seating, safe driving, and attention to passenger convenience make this service ideal for families, friends, corporate groups, and school outings."
    },
    {
      "name": "Pune Picnic Bus Booking",
      "description": "Pune Picnic Bus Booking provides easy online and offline booking options for picnic buses in Pune. Flexible scheduling, transparent pricing, and dependable vehicles make it convenient to plan family trips, school outings, corporate picnics, or weekend excursions."
    },
    {
      "name": "Tourist Picnic Bus Pune",
      "description": "Tourist Picnic Bus Pune offers comfortable and reliable buses for sightseeing and picnic tours. Spacious interiors, professional chauffeurs, and budget-friendly rates make these buses ideal for family outings, friends’ trips, and tourist excursions from Pune to nearby attractions."
    },
    {
      "name": "One Day Picnic Bus Pune",
      "description": "One Day Picnic Bus Pune provides buses for day trips and short picnic events. Ideal for families, corporate groups, or friends, these buses offer comfort, punctuality, and a hassle-free travel experience for local or nearby destinations."
    },
    {
      "name": "Weekend Picnic Bus Pune",
      "description": "Weekend Picnic Bus Pune caters to groups planning weekend trips from Pune. Spacious buses, professional drivers, and reliable service ensure a smooth, enjoyable, and safe journey for families, friends, and corporate groups."
    },
    {
      "name": "Local Picnic Bus Pune",
      "description": "Local Picnic Bus Pune provides buses for short-distance and city-based picnic outings. Comfortable, well-maintained, and driven by professional chauffeurs, these buses ensure stress-free travel for families, school groups, and friends within Pune and nearby areas."
    }
  ],
  "tableData": [
    ["Bus Service for Picnic in Pune", "Picnic Bus Hire Pune"],
    ["AC Picnic Bus Pune", "Family Picnic Bus Pune"],
    ["School Picnic Bus Pune", "Corporate Picnic Bus Pune"],
    ["Affordable Picnic Bus Pune", "Chauffeur Driven Picnic Bus"],
    ["Group Travel Picnic Bus Pune", "Best Picnic Bus Service Pune"],
    ["Pune Picnic Bus Booking", "Tourist Picnic Bus Pune"],
    ["One Day Picnic Bus Pune", "Weekend Picnic Bus Pune"],
    ["Local Picnic Bus Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "AC Bus On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides comfortable and reliable AC bus rental services in Pune, ideal for corporate trips, group tours, school excursions, and long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Air-Conditioned Buses",
    "WhyChoosedescription": "Travel in well-maintained, air-conditioned buses with ample seating and legroom for a smooth and relaxing journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune city, highways, and nearby destinations, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for AC bus rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, route planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized rental plans to meet your group’s travel requirements in Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All AC buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for AC bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide AC bus on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained AC buses for group travel in Pune.'
  },
  {
    question: 'How can I book an AC bus in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of AC buses are available for rent?',
    answer: 'We provide a range of AC buses including mini, medium, and large capacity buses suitable for groups of any size.'
  },
  {
    question: 'Are drivers included in the AC bus rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the AC bus rental service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all AC buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the AC bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for AC bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Booked an AC bus from Sanavi Travels for a group trip. Very comfortable, clean, and professional service. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Deshmukh',
    feedback: 'Excellent experience! AC bus was spacious, on-time, and the driver was courteous. Made our Pune trip enjoyable.',
    rating: 5
  }
];






































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Service for Picnic in Pune - Sanavi Travels",
  "description": "Bus service for picnics in Pune by Sanavi Travels for family outings, school picnics, corporate trips, and weekend getaways. Choose AC and luxury buses for safe, comfortable, and affordable travel for group and leisure trips.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1900"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Bus Service for Picnic in Pune Starting from ₹30 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for picnics in Pune with Sanavi Travels. AC and luxury buses for family outings, school picnics, corporate trips, and weekend getaways at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busserviceforpicniicinpune;